import Vue from 'vue'
import request from '@/helpers/request'
import { createEmployeeServices } from '@/helpers/create_employee_services'
import router from '@/router'
import store from '@/store'
import moment from 'moment'
import ServerValidationError from '@/helpers/ServerValidationError'
import userTransformer from '@/helpers/userTransformer'
import fullName from '@/helpers/full_name'
import difference from '@/helpers/difference'
import snack from '@/helpers/snack'

const MAX_NAME_LENGTH = 30

const employersAll = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.employers.all}`, { params: payload })
}
const employersOne = payload => {
  const employersOneUrl = `${Vue.config.server}/${Vue.config.modules.crm.api.employers.one.replace('$1', payload.id)}`
  return axios.get(employersOneUrl, {
    params: payload.params,
  })
}
const employerCategory = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.employers.category}`, { params: payload })
}
const employerSchedule = payload => {
  return axios.get(
    `${Vue.config.server}/${Vue.config.modules.crm.api.employers.employerSchedule.replace('$employer_id', payload.id)}`,
    { params: payload.params },
  )
}
const employerWindows = payload => {
  return axios.get(
    `${Vue.config.server}/${Vue.config.modules.crm.api.employers.windows.replace('$employer_id', payload.id)}`,
    { params: payload.params },
  )
}
const unitsAll = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.units.all}`, { params: payload })
}
const workPositionsAll = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.workPositions.all}`, payload)
}
const brandsAll = () => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.employers.brands}`)
}
const regionsAll = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.regions.all}`, payload)
}
const countriesAll = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.countries.all}`, payload)
}
const servicesAll = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.services.all}`, payload)
}
const serviceCategoriesAll = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.serviceCategories.all}`, { params: payload })
}
const metrosAll = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.metros.all}`, { params: payload })
}
const employersStatuses = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.employers.statuses}`, { params: payload })
}
const huntingResourcesAll = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.huntingResources.all}`, { params: payload })
}

const setServicesAll = payload => {
  return axios.post(
    `${Vue.config.server}/${Vue.config.modules.crm.api.employers.services.replace('$employer_id', payload.id)}`,
    { services: payload.services, service_categories: payload.serviceCategories },
  )
}

const employerDocument = payload => {
  return request(
    'GET',
    `${Vue.config.server}/${Vue.config.modules.crm.api.employers.document}`,
    {
      params: {
        limit: 1000,
        offset: 0,
        search: `employer_id:${payload.employerID}`,
        searchFields: 'employer_id:=',
        with: 'images',
      },
    },
    true,
  )
}

const documentTypesAll = payload => {
  return request(
    'GET',
    `${Vue.config.server}/${Vue.config.modules.crm.api.employers.documentType}`,
    {
      params: {
        limit: 1000,
        offset: 0,
      },
    },
    true,
  )
}

// подготовка к рефакторингу. Все условия пока сюда. Будем делать нормальные модели
const configurateParams = state => {
  let result = null
  let differentiating = null
  const statusHistory = state.employer.latest_status_history[0]
  const changedEmployerStatusId = state.employerOriginal.employer_status_id != state.employer.employer_status_id
  const differentiatedEmployer = difference(state.employer, state.employerOriginal)

  const fieldHasValue = _.some(state.employer.info.fields, item => {
    return item.hasOwnProperty('value')
  })

  if (statusHistory) {
    differentiating = difference(statusHistory.info.fields, state.employer.info.fields)
  }

  result = _.cloneDeep(differentiatedEmployer)

  if (changedEmployerStatusId || (fieldHasValue && !_.isEmpty(differentiating))) {
    result = Object.assign(result, {
      status_history: {
        employer_status_id: state.employer.employer_status_id,
        info: state.employer.info,
        created_by_employer_id: store.getters.user.id,
      },
    })
  }

  if (result.phone) result.phone = result.phone.replace('+', '').trim()

  if (
    _.get(state.employer, 'sipLogin', _.get(state.employer, 'sip_param[0].pivot.login', false)) ||
    _.get(state.employer, 'sipPassword', _.get(state.employer, 'sip_param[0].pivot.password', false))
  ) {
    Object.assign(result, {
      sipLogin: _.get(
        state.employer,
        'sipLogin',
        _.get(
          state.employer,
          'sip_param[0].pivot.login',
          _.get(store.getters.employerOriginal, 'sip_param[0].pivot.login', null),
        ),
      ),
      sipPassword: _.get(
        state.employer,
        'sipPassword',
        _.get(
          state.employer,
          'sip_param[0].pivot.password',
          _.get(store.getters.employerOriginal, 'sip_param[0].pivot.login', null),
        ),
      ),
    })
  }

  /*
    if((result.hasOwnProperty('rating') || result.hasOwnProperty('voices')) && +state.employer.rating > 0 && +state.employer.voices > 0) {
      result.rating = +state.employer.rating * +state.employer.voices;
    }
  */

  // TODO костыль, если позиция не подразумевает сервисы, но подразумевает расписание, то насильно выставляем безоконный режим расписания
  if (!state.employer.work_position.with_services && state.employer.work_position.with_schedule) {
    Object.assign(result, {
      schedule_type: 2,
    })
  }

  return result
}

export default {
  GET_HUNTING_RESOURCES({ commit, state }) {
    return huntingResourcesAll()
      .then(response => {
        const data = response.data.data
        commit('setHuntingResources', data.items)
      })
      .catch(error => {
        // console.info(error);
        Vue.notify({
          group: 'hasBottomNavigation',
          title: Vue.config.localization.ru.loadingError,
          type: 'error',
          text: error.response ? `${error.response.status} ${error.response.statusText}` : '',
        })
      })
  },

  STORE_SERVICES: ({ commit, state }, payload) => {
    return setServicesAll(payload)
  },

  GET_EMPLOYER_STATUSES: ({ commit, state }) => {
    return employersStatuses()
      .then(response => {
        const items = response.data.data
        commit('setEmployerStatuses', items)
      })
      .catch(error => {
        Vue.notify({
          group: 'hasBottomNavigation',
          title: Vue.config.localization.ru.loadingError,
          type: 'error',
          text: error.response ? `${error.response.status} ${error.response.statusText}` : '',
        })
      })
  },

  LOAD_EMPLOYERS_LIST({ commit, state }, payload) {
    let reset

    if (payload.reset) reset = true
    delete payload.reset

    return employersAll(payload).then(res => {
      const employers = userTransformer.transform(res.data.data.items, ['image', 'subtitle', 'fullName'])

      reset ? commit('setEmployers', employers) : commit('concatEmployers', employers)

      commit('setEmployerFilters', res.data.data.filters)
    })
  },

  GET_WORK_POSITIONS({ commit, state }) {
    return workPositionsAll().then(res => {
      commit('setWorkPositions', res.data.data.items)
    })
  },

  async FETCH_EMPLOYER_LIST(context, payload = {}) {
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.employers.all}`,
        { params: payload },
        true,
      )
      if (response.data.result === 'success') {
        if (payload.offset === 0) this.commit('setEmployersCounter', response.data.data.count)

        return {
          employers: userTransformer.transform(response.data.data.items, ['image', 'subtitle', 'fullName']),
          count: response.data.data.count,
        }
      } else {
        return []
      }
    } catch (e) {
      console.info(e)
      snack.add(Vue.config.localization.ru.loadingError)
      return []
    }
  },

  GET_EMPLOYERS_BRANDS({ commit }) {
    return brandsAll().then(({ data }) => {
      commit('setEmployersBrands', data)
    })
  },

  GET_EMPLOYERS_LIST: ({ commit, state }, payload) => {
    store.dispatch('GET_EMPLOYER_STATUSES')
    const unitsAllPayload = { filter: 'id;name;type' }

    return axios
      .all([employersAll(payload.employer), unitsAll(unitsAllPayload), workPositionsAll()])
      .then(
        axios.spread((employersAll, unitsAll, workPositionsAll) => {
          // bindings
          const allEmployers = employersAll.data.data
          const allUnits = unitsAll.data.data.items
          const allWorkPositions = workPositionsAll.data.data.items

          // do something with emoployers
          let employers = state.employers.concat(allEmployers.items)
          employers = userTransformer.transform(employers, ['image', 'subtitle', 'fullName'])
          commit('setEmployers', employers)
          if (!state.employersLoadedAtLeastOnce) commit('setEmployersLoadedAtLeastOnce', true)
          commit('setEmployerFilters', allEmployers.filters)

          // do something with units
          const units = store.getters.units.concat(allUnits)
          _.forEach(units, unit => {
            if (unit) unit.title = unit.name
          })
          commit('setUnits', units)

          // do something with workPositions
          commit('setWorkPositions', allWorkPositions)
        }),
      )
      .catch(error => {
        console.info(error)
        Vue.notify({
          group: 'hasBottomNavigation',
          title: Vue.config.localization.ru.loadingError,
          type: 'error',
          text: error.response ? `${error.response.status} ${error.response.statusText}` : '',
        })
      })
  },

  GET_SELECTED_HR_EMPLOYER({ commit, state }, employerID) {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.one.replace('$1', employerID)}`,
      {},
      true,
    ).then(response => {
      try {
        const hrEmployer = response.data.data
        hrEmployer.full_name = fullName.by(hrEmployer)

        commit('setEmployerField', {
          hr_mananger: hrEmployer,
        })

        const hrEmployers = _.cloneDeep(state.hrEmployers)
        hrEmployers.unshift(hrEmployer)
        commit('setHrEmployers', hrEmployers)
      } catch (e) {
        console.info(e)
      }
    })
  },

  GET_HR_EMPLOYERS({ commit, state }, payload) {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.all}`,
      {
        params: payload.params ? payload.params : {},
      },
      true,
    ).then(response => {
      const data = response.data.data

      _.forEach(data.items, hrEmployer => {
        hrEmployer.full_name = fullName.by(hrEmployer)
        hrEmployer.title = fullName.by(hrEmployer)
      })

      if (payload.reset) {
        commit('setHrEmployers', [])
      }

      commit('setHrEmployers', state.hrEmployers.concat(data.items))
    })
  },
  GET_UNITS({ commit }) {
    return unitsAll({
      filter: 'id;company_id;name;type;timezone;default_store_id',
      sortedBy: 'asc',
      orderBy: 'name',
    }).then(res => {
      const units = res.data.data.items

      for (let i = 0; i < units.length; i++) {
        units[i].title = units[i].name
      }
      commit('setUnits', units)
    })
  },

  async GET_EMPLOYER({ commit, dispatch, state, getters }, employerID) {
    const employersOnePayload = {
      id: employerID,
      params: {
        with:
          'workPosition;' +
          'services;' +
          'sipParam;' +
          'hrManager;' +
          'statusHistories;' +
          'statusHistories.status;' +
          'statusHistories.createdBy;' +
          'latestStatusHistory;' +
          'employerStatus;' +
          'ticketGroups',
      },
    }

    try {
      const employersOneResponse = await employersOne(employersOnePayload)

      let oneEmployer = employersOneResponse.data.data
      oneEmployer = userTransformer.transform(oneEmployer, ['image', 'rating'])
      const scheduleType = employersOneResponse.data.form

      if (oneEmployer.latest_status_history && oneEmployer.latest_status_history[0]) {
        oneEmployer.info = _.cloneDeep(oneEmployer.latest_status_history[0].info)
      } else {
        oneEmployer.info = {
          fields: [],
        }
      }

      // actions with oneEmployer
      commit('setEmployer', oneEmployer)
      commit('setEmployerOriginal', _.cloneDeep(oneEmployer))
      commit('setEmployerServicesAndCategory', oneEmployer)
      commit('setTitle', fullName.by(oneEmployer, MAX_NAME_LENGTH))
      commit('setEmployerScheduleType', scheduleType)

      const serviceCategoriesPayload = {
        with: 'services',
        offset: 0,
        limit: 30,
      }

      const serviceCategoriesAllResponse = await serviceCategoriesAll(serviceCategoriesPayload)
      store.dispatch('GET_EMPLOYER_STATUSES')
      const serviceIDs = state.employer.serviceIDs
      // Modify service categories for employer
      if (state.employer.serviceIDs) {
        const serviceCategories = createEmployeeServices(
          serviceCategoriesAllResponse.data.data.items,
          serviceIDs,
          state.employer.serviceCategoryIDs,
        )
        commit('setServiceCategories', serviceCategories)
      }
      // PAYLOADS!!!
      const unitsAllPayload = { filter: 'id;name' }
      const metrosPayload = {
        search: `city_id:${state.employer.city_id}`,
        searchFields: 'city_id:=',
        with: 'metroLine',
      }
      const employerWindowsPayload = { id: employerID, params: {} }
      const employersAllPayload = {
        search: `workPosition.title:${Vue.config.statuses.workPositionOffice}`,
        searchFields: 'workPosition.title:like',
        offset: 0,
        limit: 1000,
      }
      const employerSchedulePayload = {
        id: employerID,
        params: {
          with: 'workplace.unit;unit',
          search: `begin_at:${moment().format('YYYY-MM-DD')};end_at:${moment().add(14, 'days').format('YYYY-MM-DD')}`,
          searchFields: 'begin_at:>=;end_at:<=',
          searchJoin: 'and',
          orderBy: 'begin_at',
          sortedBy: 'asc',
        },
      }
      const employerDocumentPayload = { employerID }

      const requests = [
        employersOne(employersOnePayload),
        employerCategory(),
        workPositionsAll(),
        regionsAll(),
        countriesAll(),
        employersAll(employersAllPayload),
        unitsAll(unitsAllPayload),
        employerSchedule(employerSchedulePayload),
        employerWindows(employerWindowsPayload),
        metrosAll(metrosPayload),
        documentTypesAll(),
        employerDocument(employerDocumentPayload),
      ]

      const allResponses = await axios.all(requests)

      ;(([
        employersOne,
        employerCategory,
        workPositionsAll,
        regionsAll,
        countriesAll,
        employersAll,
        unitsAll,
        employerSchedule,
        employerWindows,
        metrosAll,
        documentTypesAll,
        employerDocument,
      ]) => {
        // bindings
        const categoryEmployer = employerCategory.data.data.items
        const allWorkPositions = workPositionsAll.data.data.items
        const allRegions = regionsAll.data.data.items
        const allCountries = countriesAll.data.data.items
        const allEmployers = employersAll.data.data.items
        const allUnits = unitsAll.data.data.items
        const scheduleEmployer = employerSchedule.data.data
        const windowsEmployer = employerWindows.data.data.items
        const allMetros = metrosAll.data.data.items
        const allDocumentTypes = documentTypesAll.data.data.items
        const employerDocumentResponse = employerDocument.data.data.items

        // actions with CategoryEmployer
        commit('setEmployerCategories', categoryEmployer)

        // actions with workPositions
        commit('setWorkPositions', allWorkPositions)

        // actions with regions
        commit('setRegions', allRegions)

        // actions with countries
        commit('setCountries', allCountries)

        // actions with hrEmployers
        _.forEach(allEmployers, hrEmployer => {
          hrEmployer.full_name = fullName.by(hrEmployer)
        })

        dispatch('GET_HR_EMPLOYERS', {
          params: {
            search: 'work_position_id:12',
            searchFields: 'work_position_id:=',
            offset: 0,
            limit: 100,
          },
          reset: true,
        })

        if (state.employer.hr_manager) {
          dispatch('GET_SELECTED_HR_EMPLOYER', state.employer.hr_manager.id)
        }

        // TODO Тут какая-то херня. Пока что мы предпологаем, что у нас только один документ. По факту их будет много.
        if (employerDocumentResponse.length === 1) {
          commit('setEmployerDocument', _.first(employerDocumentResponse))
        } else {
          commit('setEmployerDocument', {
            number: null,
            issued_at: null,
            employer_document_type_id: null,
            attachment: null,
          })
        }

        commit('setDocumentTypes', allDocumentTypes)
        // TODO Костыль #хардкодзачас crutch set first value that comes  as selected document type. Because now we only support one type
        const passport = _.first(allDocumentTypes)
        if (passport) {
          commit('setEmployerDocumentField', { field: 'employer_document_type_id', value: passport.id })
        }
        // actions with units
        const units = store.getters.units.concat(allUnits)
        _.forEach(units, unit => {
          if (unit) unit.title = unit.name
        })
        commit('setUnits', units)

        // actions with employerSchedule
        commit('setEmployerShedule', scheduleEmployer)

        // actions with windows
        commit('employer_windows/setWindows', windowsEmployer)

        // actions with metros
        commit('setMetros', store.getters.metros.concat(allMetros))
      })(allResponses)
    } catch (error) {
      console.info(error)
      Vue.notify({
        group: 'hasBottomNavigation',
        title: Vue.config.localization.ru.loadingError,
        type: 'error',
        text: error.response ? `${error.response.status} ${error.response.statusText}` : '',
      })
    }
  },

  GET_NEW_EMPLOYER_DATA: ({ commit, state, dispatch }) => {
    commit('setEmployerDocument', { number: null, issued_at: null, employer_document_type_id: null })
    store.dispatch('GET_EMPLOYER_STATUSES')
    const employersAllPayload = {
      offset: 0,
      limit: 30,
      with: 'workPosition',
      filter: 'id;first_name;middle_name;last_name;work_position_id',
    }
    return axios
      .all([
        employersAll(employersAllPayload),
        workPositionsAll(),
        regionsAll(),
        countriesAll(),
        unitsAll(),
        documentTypesAll(),
      ])
      .then(
        axios.spread((employersAll, workPositionsAll, regionsAll, countriesAll, unitsAll, documentTypes) => {
          // bindings
          const allEmployers = employersAll.data.data
          const allWorkPositions = workPositionsAll.data.data.items
          const allRegions = regionsAll.data.data.items
          const allCountries = countriesAll.data.data.items
          const allUnits = unitsAll.data.data.items
          const allDocumentTypes = documentTypes.data.data.items

          // do something with emoployers
          let employers = state.employers.concat(allEmployers.items)
          employers = userTransformer.transform(employers, ['image', 'subtitle', 'fullName'])
          commit('setEmployers', employers)
          commit('setEmployerFilters', allEmployers.filters)

          // do something with workPositions
          commit('setWorkPositions', allWorkPositions)

          // do something with countries
          commit('setRegions', allRegions)

          // do something with serviceCategories
          commit('setCountries', allCountries)

          commit('setDocumentTypes', allDocumentTypes)
          // TODO Костыль crutch set first value that comes  as selected document type. Because now we only support one type
          const passport = _.first(allDocumentTypes)
          if (passport) {
            commit('setEmployerDocumentField', { field: 'employer_document_type_id', value: passport.id })
          }

          // do something with Units
          const units = store.getters.units.concat(allUnits)
          _.forEach(units, unit => {
            if (unit) unit.title = unit.name
          })
          commit('setUnits', units)
        }),
      )
      .catch(error => {
        console.info(error)
        Vue.notify({
          group: 'hasBottomNavigation',
          title: Vue.config.localization.ru.loadingError,
          type: 'error',
          text: error.response ? `${error.response.status} ${error.response.statusText}` : '',
        })
      })
  },

  async UPDATE_EMPLOYER({ commit, state, dispatch }) {
    const params = configurateParams(state)
    if (state.employer.phone.search(/[*]+/) != -1) {
      delete params.phone
    }
    if (!_.isEmpty(state.employer.password)) {
      params.password = state.employer.password
    }

    if (params.avatar) delete params.avatar
    // if (!state.employer.is_superuser) {
    // _.set(params, 'is_superuser', true);
    // }

    let employerResponse
    try {
      // @ToDo: грязный хак, вставляем всего эмплоера, а то блядь оно не работало, а разбираться очень впадлу.
      employerResponse = await request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.employers.one.replace('$1', state.employer.id)}`,
        params,
        true,
      )
    } catch (e) {
      ServerValidationError.notify(e, 'employerValidation')
    }

    if (employerResponse.data.result === 'success') {
      const employer = employerResponse.data.data
      _.forEach(store.getters.workPositions, item => {
        if (employer.work_position_id === item.id) employer.subtitle = item.title
      })

      commit('changeEmployer', { key: state.employer.id, value: employer })

      const SERVICE_CATEGORIES_ARRAY = []
      const SERVICES_OBJ = {}
      const STORE_SERVICE_CATEGORIES = store.getters.serviceCategories
      _.each(STORE_SERVICE_CATEGORIES, category => {
        const CATEGORY_SERVICES = category.services
        if (category.active) {
          SERVICE_CATEGORIES_ARRAY.push(category.id)
        }
        _.each(CATEGORY_SERVICES, service => {
          if (service.active) {
            SERVICES_OBJ[service.id] = {
              duration: service.duration,
            }
          }
        })
      })

      await store.dispatch('STORE_SERVICES', {
        id: state.employer.id,
        services: SERVICES_OBJ,
        serviceCategories: SERVICE_CATEGORIES_ARRAY,
      })

      await store.dispatch('employer_windows/SAVE_WINDOW', 0)

      await store.dispatch('GET_EMPLOYER_STATUS_HISTORIES', state.employer.id)

      let latestEmployerDocuments
      try {
        latestEmployerDocuments = await employerDocument({ employerID: state.employer.id })
        latestEmployerDocuments = _.find(
          latestEmployerDocuments.data.data.items,
          item => item.employer_document_type_id === 1,
        )
      } catch (e) {
        Vue.notify({
          group: 'hasBottomNavigation',
          title: Vue.config.localization.ru.documentsLoadingErrorMessage,
          type: 'error',
          text: e.response ? `${e.response.status} ${e.response.statusText}` : '',
        })
      }
      const formData = new FormData()
      const documentParamsNotEmpty = _.some(state.employerDocument, item => {
        return !_.isEmpty(item)
      })
      const differrenciate = difference(state.employerDocument, latestEmployerDocuments ? latestEmployerDocuments : {})

      if (documentParamsNotEmpty && !_.isEmpty(differrenciate)) {
        const saveEmployerDocumentParams = {}
        _.each(differrenciate, (val, key) => {
          if (_.isNull(val)) return
          if (key === 'attachment') {
            formData.append(key, _.first(val))
            return
          }
          formData.append(key, val)
        })
        formData.append('employer_id', state.employer.id)
        formData.append('company_id', state.employer.company_id)
        if (latestEmployerDocuments) {
          formData.append('_method', 'PUT')
          saveEmployerDocumentParams.documentID = latestEmployerDocuments.id
        }
        saveEmployerDocumentParams.params = formData
        dispatch('SAVE_EMPLOYER_DOCUMENT', saveEmployerDocumentParams)
      }

      await store.dispatch('GET_EMPLOYER', state.employer.id)

      snack.add(Vue.config.localization.ru.savedMessage, 'primary')
    }
  },

  GET_EMPLOYER_STATUS_HISTORIES({ commit, state }, employerId) {
    employersOne({
      id: employerId,
      params: { with: 'statusHistories.status;latestStatusHistory;statusHistories.createdBy' },
    }).then(response => {
      commit('setEmployerField', {
        key: 'status_histories',
        value: response.data.data.status_histories,
      })
      commit('setEmployerField', {
        key: 'latest_status_history',
        value: response.data.data.latest_status_history,
      })
    })
  },

  async CREATE_EMPLOYER({ commit, dispatch, state }) {
    const params = Object.assign(_.cloneDeep(state.employer), {
      status_history: {
        employer_status_id: state.employer.employer_status_id,
        info: state.employer.info,
        created_by_employer_id: store.getters.user.id,
      },
      created: true,
    })

    if (params.password === null) {
      params.password = Math.random().toString(36).slice(-8)
    }
    params.phone = params.phone.replace('+', '').trim()

    if (state.employer.sipLogin && state.employer.sipLogin.length) {
      Object.assign(params, {
        sipLogin: state.employer.sipLogin,
      })
    }
    if (state.employer.sipPassword && state.employer.sipPassword.length) {
      Object.assign(params, {
        sipPassword: state.employer.sipPassword,
      })
    }

    let createEmployerResponse
    try {
      createEmployerResponse = await request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.employers.all}`,
        params,
        true,
      )
    } catch (error) {
      ServerValidationError.notify(error, 'employerValidation')
      if (error.data.result === 'error') {
        const data = error.data
        commit('setEmployerErrors', data.errors)
      }
    }
    if (createEmployerResponse.data.result === 'success') {
      const data = createEmployerResponse.data.data
      commit('setEmployerField', { key: 'id', value: data.id })
      commit('setTitle', fullName.by(state.employer, MAX_NAME_LENGTH))
      commit('unshiftEmployers', { ...state.employer })

      dispatch('employer_windows/SAVE_WINDOW', 0)

      const formData = new FormData()
      const documentParamsNotEmpty = _.some(state.employerDocument, item => {
        return !_.isEmpty(item)
      })

      if (documentParamsNotEmpty) {
        const saveEmployerDocumentParams = {}
        _.each(state.employerDocument, (val, key) => {
          if (_.isNull(val)) return
          if (key === 'attachment') {
            formData.append(key, _.first(val))
            return
          }
          formData.append(key, val)
        })
        formData.append('employer_id', data.id)
        formData.append('company_id', data.company_id)
        saveEmployerDocumentParams.params = formData
        await dispatch('SAVE_EMPLOYER_DOCUMENT', saveEmployerDocumentParams)
      }

      if (!_.isEmpty(params.avatar)) {
        const avatarData = new FormData()
        avatarData.append('avatar', params.avatar_blob)
        await dispatch('UPDATE_USER_AVATAR', { employerID: data.id, formData: avatarData })
      }
      router.push({
        path: Vue.config.modules.crm.route.employers.one.replace('$1', data.id),
      })
      snack.add(Vue.config.localization.ru.savedMessage, 'primary')
    } else {
      snack.add(Vue.config.localization.ru.errorCreatingEmployer)
    }
  },

  DELETE_EMPLOYER: ({ commit, state }) => {
    request(
      'DELETE',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.one.replace('$1', state.employer.id)}`,
      {},
      true,
    ).then(
      response => {
        if (response.data.result === 'success') {
          commit('deleteEmployer', state.employer.id)
          const employersLength = state.employers.length

          if (employersLength != 0) {
            store.dispatch('GET_EMPLOYER', state.employers[0].id)

            commit('setEmployerErrors', null)

            router.push({
              path: Vue.config.modules.crm.route.employers.one.replace('$1', state.employers[0].id),
            })

            Vue.notify({
              group: 'hasBottomNavigation',
              title: '',
              type: 'success',
              text: Vue.config.localization.ru.deleteMessage,
            })
          } else {
            router.push({ path: Vue.config.modules.crm.route.employers.all })
          }
        } else {
          commit('setServiceErrors', null)

          Vue.notify({
            group: 'hasBottomNavigation',
            title: '',
            type: 'error',
            text: Vue.config.localization.ru.notFoundMessage,
          })
          // TODO: Show error dialog
        }
      },
      e => {
        ServerValidationError.notify(e, 'customerValidation')
      },
    )
  },

  RESTORE_EMPLOYER: ({ commit, state }, payload) => {
    const employer_id = payload ? payload : state.employer.id

    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'PATCH',
        `${Vue.config.server}/${Vue.config.modules.crm.api.employers.one.replace('$1', employer_id)}`,
        {},
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          if (!payload) {
            commit('setEmployerField', { key: 'deleted_at', value: null })
          }

          snack.add(Vue.config.localization.ru.successRestore, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.errorRestoreMessage)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },

  GET_EMPLOYER_SERVICES: ({ commit, state }, employerID) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.services.replace('$employer_id', employerID)}`,
      {},
      true,
    ).then(response => {
      commit('setEmployerServices', response.data.data)
    })
  },

  async FETCH_EMPLOYER_SERVICES({ commit, state }, employerID) {
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.employers.services.replace('$employer_id', employerID)}`,
        {},
        true,
      )
      return response.data.data.services
    } catch (e) {
      console.info(e)
      snack.add(Vue.config.localization.ru.loadingError)
      return []
    }
  },

  GET_SERVICE_EMPLOYERS_BY_SERVICE: ({ commit, state }, serviceCategoryID) => {
    commit('setLoadingServiceEmployers', true)
    if (state.serviceEmployers.length > 0) {
      commit('setServiceEmployers', [])
    }
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.all}`,
      {
        params: {
          with: 'allServices',
          search: `allServices.id:${serviceCategoryID};work_position_id:1,14`,
          searchFields: 'allServices.id:=;work_position_id:in',
          limit: 30,
          offset: 0,
          searchJoin: 'and',
          orderBy: 'last_name',
          sortedBy: 'asc',
        },
      },
      true,
    ).then(response => {
      let serviceEmployers = response.data.data.items

      serviceEmployers = userTransformer.transform(serviceEmployers, ['image', 'fullName'])

      commit('setServiceEmployers', serviceEmployers)
      commit('setLoadingServiceEmployers', false)
    })
  },

  GET_SERVICE_EMPLOYERS_BY_SERVICE_SCROLLABLE: ({ commit, state }, payload) => {
    commit('setLoadingServiceEmployers', true)
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.all}`,
      {
        params: {
          with: 'allServices',
          search: payload.search,
          searchFields: payload.searchFields,
          limit: payload.limit,
          offset: payload.offset,
          searchJoin: 'and',
          orderBy: 'last_name',
          sortedBy: 'asc',
        },
      },
      true,
    ).then(response => {
      let serviceEmployers = response.data.data.items

      serviceEmployers = userTransformer.transform(serviceEmployers, ['image', 'fullName'])

      commit('updateServiceEmployers', serviceEmployers)
      commit('setLoadingServiceEmployers', false)
    })
  },
  GET_EMPLOYER_DOCUMENT_TYPES({ commit, state }, payload) {
    return documentTypesAll(payload).then(response => {
      if (response.data.result === 'success') {
        commit('setDocumentTypes', response.data.data.items)
        return response
      }
    })
  },
  GET_EMPLOYER_DOCUMENT({ commit, state }, payload) {
    return employerDocument(payload)
  },

  SAVE_EMPLOYER_DOCUMENT({ commit, state }, { method = 'POST', params, documentID = null }) {
    return request(
      method,
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.document}${
        documentID !== null ? `/${documentID}` : ''
      }`,
      {
        data: params,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Content-Disposition': 'x-www-form-urlencoded',
        },
      },
    )
      .then(response => {
        return response
      })
      .catch(e => {
        Vue.notify({
          group: 'hasBottomNavigation',
          title: Vue.config.localization.ru.documentsSaveErrorMessage,
          type: 'error',
          text: e.response ? `${e.response.status} ${e.response.statusText}` : '',
        })
      })
  },

  UPDATE_USER_AVATAR({ commit, state }, { employerID, formData }) {
    formData.append('_method', 'PUT')
    return request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.one.replace('$1', employerID)}`,
      {
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
      .then(res => {
        if (res.data.result === 'success') {
          const result = userTransformer.transform(res.data.data, ['image'])
          commit('setEmployerField', { key: 'avatar', value: result.avatar })
          snack.add(Vue.config.localization.ru.avatarSavedMessage, 'primary')
        }
      })
      .catch(error => {
        Vue.notify({
          group: 'hasBottomNavigation',
          title: Vue.config.localization.ru.avatarSavedErrorMessage,
          type: 'error',
          text: error.response ? `${error.response.status} ${error.response.statusText}` : '',
        })
      })
  },

  GET_EMPLOYERS_BY_SCHEDULE({ commit, state, rootGetters }, params) {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.schedule}`,
      {
        params,
        headers: {
          'X-Timezone': rootGetters.timezone ? rootGetters.timezone : 'Europe/Moscow',
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        return response
      }
    })
  },

  async GET_EMPLOYERS_FOR_AUTOCOMPLETE(context, params) {
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.employers.all}`,
        {
          params: {
            search: `id:${params}`,
            searchFields: 'id:plastic:employer',
            searchJoin: 'and',
            limit: 100,
            offset: 0,
          },
        },
        true,
      )
      return _.map(response.data.data.items, employer => {
        employer.name = fullName.by(employer, void 0, true)
        return employer
      })
    } catch (e) {
      console.info(e)
      return []
    }
  },

  async GET_EMPLOYERS_FOR_AUTOCOMPLETE_ONLY_MASTERS(context, params) {
    try {
      const search = 'workPosition.type_position:master,top_master;blocked_at:null;end_work_at:null'
      const searchFields = 'workPosition.type_position:in;blocked_at:null;end_work_at:null'

      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.employers.all}`,
        {
          params: {
            search: `id:${params};${search}`,
            searchFields: `id:plastic:employer;${searchFields}`,
            searchJoin: 'and',
            limit: 100,
            offset: 0,
          },
        },
        true,
      )
      return _.map(response.data.data.items, employer => {
        employer.name = fullName.by(employer, void 0, true)
        return employer
      })
    } catch (e) {
      console.info(e)
      return []
    }
  },
  async GET_EMPLOYERS_FOR_AUTOCOMPLETE_ONLY_SUPERUSER(context, params = '') {
    try {
      const search = 'workPosition.id:174;blocked_at:null'
      const searchFields = 'workPosition.id:in;blocked_at:1'

      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.employers.all}`,
        {
          params: {
            search: `${search}`,
            searchFields: `${searchFields}`,
            searchJoin: 'and',
            limit: 100,
            offset: 0,
          },
        },
        true,
      )
      return _.map(response.data.data.items, employer => {
        employer.name = fullName.by(employer, void 0, true)
        return employer
      })
    } catch (e) {
      console.info(e)
      return []
    }
  },

  async GET_EMPLOYERS_FOR_AUTOCOMPLETE_WITH_PARAMS(context, { searchString, employerType }) {
    let search = ''
    let searchFields = ''
    if (employerType === Vue.config.modules.crm.employerSearchTypes.UNBLOCKED_MASTERS_AND_TOP_MASTERS) {
      search = 'workPosition.type_position:master,top_master,administrator;blocked_at:null'
      searchFields = 'workPosition.type_position:in;blocked_at:1'
    }
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.employers.all}`,
        {
          params: {
            search: `id:${searchString};${search}`,
            searchFields: `id:plastic:employer;${searchFields}`,
            searchJoin: 'and',
            limit: 100,
            offset: 0,
          },
        },
        true,
      )
      return _.map(response.data.data.items, employer => {
        employer.name = fullName.by(employer, void 0, true)
        return employer
      })
    } catch (e) {
      console.info(e)
      return []
    }
  },
  async GET_EMPLOYERS_FOR_AUTOCOMPLETE_WITH_PARAMS_WITH_BLOCKED_FIRED_MARKS(context, params) {
    let employers = await this.dispatch('GET_EMPLOYERS_FOR_AUTOCOMPLETE_WITH_PARAMS', params)

    return _.map(employers, employer => {
      return fullName.getBlockedOrFiredMessage(employer)
    })
  },
}
